export const CODE_NATURALEZA_VENTAS = '20';
export const CODE_NATURALEZA_COMPRAS = '10';
export const CODE_NATURALEZA_ORDEN_SERVICIO = '04';
export const CODE_NATURALEZA_REMISION_COMPRAS = '11';
export const CODE_NATURALEZA_DEVOL_COMPRAS = '12';
export const CODE_NATURALEZA_GASTOS = '14';
export const CODE_NATURALEZA_REMISION_VENTAS_FACT = '21';
export const CODE_NATURALEZA_DEVOL_VENTAS = '22';
export const CODE_NATURALEZA_REMISION_VENTAS_FACTURADAS_WMS = '30';
export const CODE_NATURALEZA_DEVOL_REMIS_VENTA = '32';
export const CODE_NATURALEZA_ANULACION_REMIS_VENTA = '34';
export const CODE_NATURALEZA_ANTICIPO_CLIENTE = '39';
export const CODE_NATURALEZA_ANTICIPO_PROVEEDOR = '40';


// WEBPACK FOOTER //
// ./src/util/documentNatureConstants.js